import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './index.scss';

const Page = ({ children, className, noPadding }) => {
    const pageClass = classNames({
        // container: true,
        [styles.page]: true,
        [styles.noPadding]: noPadding,
        [className]: !!className,
    });
    return <div className={pageClass}>{children}</div>;
};

Page.propTypes = {
    className: PropTypes.string,
    noPadding: PropTypes.bool,
};
Page.defaultProps = {
    className: '',
    noPadding: false,
};

export default Page;
